import { render, staticRenderFns } from "./expressDelivery.vue?vue&type=template&id=a9228722&scoped=true&"
import script from "./expressDelivery.vue?vue&type=script&lang=js&"
export * from "./expressDelivery.vue?vue&type=script&lang=js&"
import style0 from "./expressDelivery.vue?vue&type=style&index=0&id=a9228722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9228722",
  null
  
)

export default component.exports